import { apiRequest } from './api';
import { Server, ServerRequest } from '../types/server';

export const serverService = {
  // Get all servers
  getAllServers: async (): Promise<Server[]> => {
    return await apiRequest<Server[]>('/servers');
  },

  // Get server by ID
  getServerById: async (id: number): Promise<Server> => {
    return await apiRequest<Server>(`/servers/${id}`);
  },

  // Create new server
  createServer: async (server: ServerRequest): Promise<Server> => {
    return await apiRequest<Server>('/servers/create', {
      method: 'POST',
      body: JSON.stringify(server)
    });
  },

  // Update existing server
  updateServer: async (id: number, server: ServerRequest): Promise<Server> => {
    return await apiRequest<Server>(`/servers/${id}`, {
      method: 'PUT',
      body: JSON.stringify(server)
    });
  },

  // Delete server
  deleteServer: async (id: number): Promise<void> => {
    return await apiRequest<void>(`/servers/${id}`, {
      method: 'DELETE'
    });
  }
}; 